module.exports = __webpack_public_path__ + "static/media/furniture_big_img.4353f0f2.jpg";